import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';

const MatchMobileContainer = ({ renderMobile, renderDesktop }) => {
  const matches = useMediaQuery(`(max-width: 767px)`, { noSsr: true });

  if (matches) {
    return renderMobile();
  }

  return renderDesktop();
};

export default MatchMobileContainer;
